import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 查询期数列表
   */
  static getPeriodList(params) {
    return request({
      url: `performance/period/List`,
      host: config.HOST_PROMOTE,
      params
    });
  }

  /**
   * 查询复消列表
   */
  static getDeconPeriodList(params) {
    return request({
      url: `tradecore/period/list/recent/period`,
      host: config.HOST_PROMOTE,
      params
    });
  }

  /**
   * 查询复消结果
   */
  static getQueryFxPassOrNot(params) {
    return request({
      url: `performance/queryMemberFxPassOrNot/` + params.cardCode,
      host: config.HOST_PROMOTE,
      method: 'post_json',
      data: params.period
    });
  }

  /**
   * 查询个人业绩
   */
  static getPersonalAchieve(params) {
    return request({
      url: `performance/personal`,
      host: config.HOST_PROMOTE,
      params
    });
  }

  /**
   * 查询区域业绩
   */
  static getRegionAchieve(params) {
    return request({
      url: `performance/area`,
      host: config.HOST_PROMOTE,
      params
    });
  }

  /**
   * 查询零售区域业绩
   */
  static getRetailRegionAchieve(params) {
    return request({
      url: `performance/retailArea`,
      host: config.HOST_PROMOTE,
      params
    });
  }

  /**
   * 我的销售费
   */
  static getCommission(filter) {
    return request({
      url: `performance/queryCommissionList/${filter}`,
      host: config.HOST_PROMOTE
    });
  }

  /**
   * 销售费发放失败列表
   */
  static getCommissionFail() {
    return request({
      url: `performance/queryCommissionList/fail`,
      host: config.HOST_PROMOTE
    });
  }

  /**
   * 查询用户是否可以申请补发销售费
   */
  static getCommissionSent() {
    return request({
      url: `performance/queryCommissionSent`,
      host: config.HOST_PROMOTE
    });
  }

  /**
   * 提交补发销售费申请
   */
  static applyCommission(params) {
    return request({
      url: `performance/applyCommissionSent`,
      host: config.HOST_PROMOTE,
      method: 'post_json',
      data: params,
      ignoreErr: true
    });
  }

  /**
   * 查询会员续约
   */
  static getMemberRenewal(params) {
    return request({
      url: `performance/queryReNewDetail`,
      host: config.HOST_PROMOTE,
      params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Promote/Achievement/AchievementServ.js